import React from 'react';
import { useTranslation } from 'react-i18next';

import { useActions } from '@mssgme/hooks';
import { ImageField } from '@mssgme/ui';
import { FieldTip, ImageUploadAvatar } from '@mssgme/app/components/UI';
import CardEditForm from '../CardEditForm';

export default function AvatarEdit() {
    const { t } = useTranslation('cards');
    const actions = useActions();

    return (
        <CardEditForm title={t('AvatarEdit.title')}>
            {({ values }) => (
                <div style={{ textAlign: 'center' }}>
                    <ImageField
                        accept="image/png,image/x-png,image/jpeg"
                        as={ImageUploadAvatar}
                        name="design.photo"
                        previewName="design.photoUrl"
                        previewUrl={values.design.photoUrl}
                        buttonLabel={t('designEdit.change_photo')}
                        upload={actions.api.card.uploadAvatar}
                    />
                    <FieldTip>{t('FieldTip.avatar')}</FieldTip>
                </div>
            )}
        </CardEditForm>
    );
}
